import { Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { merge, Observable, throwError } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

import type { Candidate } from '@recruitee/candidate-types';
import type { MailboxConvertData } from '@recruitee/mailbox-types';
import { generateUuid } from '@recruitee/utils';

import { MailboxThreadsActions } from './mailbox-threads.store';

@Injectable({ providedIn: 'root' })
export class MailboxConvertService {
  constructor(
    private store: Store,
    private actions$: Actions,
  ) {}

  public convertCandidate(convertData: MailboxConvertData): Observable<Candidate> {
    const uuid = generateUuid();
    this.store.dispatch(
      MailboxThreadsActions.convert({ payload: { data: convertData, correlationId: uuid } }),
    );
    return merge(
      this.actions$.pipe(
        ofType(MailboxThreadsActions.convertSuccess),
        filter(({ payload }) => payload.correlationId === uuid),
        take(1),
        map(({ payload }) => payload.data),
      ),
      this.actions$.pipe(
        ofType(MailboxThreadsActions.convertFailed),
        filter(({ payload }) => payload.correlationId === uuid),
        take(1),
        switchMap(({ payload }) => throwError(payload.error)),
      ),
    );
  }
}
